import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Products() {
  const { t, i18n } = useTranslation();
  const [language, setLanguage] = useState(i18n.language);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedProduct, setSelectedProduct] = useState<any>(null);
  const [showPdfViewer, setShowPdfViewer] = useState(false);

  // SEO Meta Tags
  useEffect(() => {
    document.title = 'Ürünlerimiz - Güventar Sistemleri | Damla Sulama ve Tarımsal Sulama Ürünleri';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'GüvenTar Sistemleri ürün katalogu. Damla sulama, yağmurlama, mikro yağmurlama sistemleri, otomatik kontrol ve filtre sistemleri. Kaliteli tarımsal sulama çözümleri.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'ürünler, damla sulama, yağmurlama, mikro yağmurlama, otomatik kontrol, filtre sistemleri');
    }

    const canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      canonicalLink.setAttribute('href', `${import.meta.env.VITE_SITE_URL || 'https://www.guventar.com'}/urunlerimiz`);
    }
  }, []);

  const toggleLanguage = () => {
    const newLang = language === 'tr' ? 'en' : 'tr';
    setLanguage(newLang);
    i18n.changeLanguage(newLang);
  };
  // Ürün kategorileri
  const categories = [
    { id: 'all', name: 'Güventar', icon: 'ri-apps-line' },
   
  ];

  // Ürünler
  const products = [
    {
      id: 1,
      name: 'Sfs Filtre Sulama Sistemleri',
      category: '',
      image: 'images/sfs.jpeg',
      shortDesc: 'Yüksek verimli damla sulama sistemi',
      
      features: [],
      specs: {
        
      },
      usageAreas: [''],
      description:
        'Dürüst ve adaletli davranarak müşteri memnuniyetini her şeyin üzerinde tutarak, bilimden ve analitik düşünceden ödün vermeden, toplumsal sorumluluklara riayat ederek, yenilikçi sürekli takip ederek dünya standartlarında ürün ve hizmet sunmaktır.'
    },
    {
      id: 2,
      name: 'Poelsan Boru Bağlantı Adaptör',
      category: 'all',
      image:
        'images/poelsan.jpeg',
      shortDesc: 'Polietilen Kangal Boru Bağlantı Adaptörleri',
      price: '₺3.000 - ₺20.000',
      features: ['2 yıl garanti'],
      specs: {
        
      },
      usageAreas: [''],
      description:
        'Suyun doğru kullanımına yönelik çözüm odaklı ve yenilikçi ürün çeşitliliğini sürekli artırarak Dünya’nın suyuna yön veren Poelsan ürünleri; başta peyzaj sektörü olmak üzere içme suyu şebekelerinde, tarım alanlarında, petrol, doğalgaz ve madencilik sektörlerinde güvenle kullanılmaktadır.'
    },
    {
      id: 3,
      name: 'Jetplast Sulama Sistemleri',
      category: 'all',
      image:
        'images/jetplas.jpeg',
      shortDesc: 'Yüksek verimli damla sulama sistemi',
      price: '₺1.800 - ₺8.000',
      features: [ '2 yıl garanti'],
      specs: {
        
      },
      usageAreas: [''],
      description:
        'Küresel vanalar, çelik kollu küresel vanalar, kaplinli küresel vanalar, damlama ek parçalar, hava vantuzları, filtreler, mini sprinkler, mini sprink takımları, sprink ek parçalar ve kilitli ek parçalar ile damlama ve yağmurlama sulama parçaları ile hizmetlerimizle çalışmalarımızı özveriyle, hizmet kalitemizle sektörde büyüyerek sağlamlaştırmaktadır.'
    },
    {
      id: 4,
      name: 'Klepsan Vana ve Ölçü Aletleri',
      category: 'all',
      image:
        'images/klepsan.jpeg',
      shortDesc: 'Akıllı sulama kontrolü',
      price: '₺5.000 - ₺25.000',
      features: ['2 yıl garanti'],
      specs: {
        
      },
      usageAreas: [''],
      description:
        'En son teknoloji ile donatılmış makine parkurumuzla,deneyimli ve professionel satış ve üretim ar-ge kadrosu ile, TSE (TS3148- TS3147- TS579-EN 331),ISO 9001:2000,PCT (GOST) kalite belgeleri ile ve Türk malı Ürün üretmenin verdiği gururla siz değerli müşterilerimize ve ülkemize hizmet etmeye devam edeceğiz.'
    },
    {
      id: 5,
      name: 'Sıray Çekvalf ve Yangın ',
      category: 'all',
      image:
        'images/siray.jpeg',
      shortDesc: 'Su arıtma ve filtreleme',
      price: '₺2.000 - ₺12.000',
      features: ['2 yıl garanti'],
      specs: {
       
      },
      usageAreas: [''],
      description:
        'Cek valf ve yangın söndürme malzemeleri ; Yangın söndürme sektöründeki markalaşma ve ticari itibarını yüceltme konusundaki başarısıyla adından sıkça söz ettirerek, bugünlere gelmiş ve aydınlık bir geleceği vizyon edinmenin gururuyla, güçlükler karşısında yılmadan faaliyetlerine devam etmiştir.'
    },
    {
      id: 6,
      name: 'Bkv Vana Sistemleri',
      category: 'all',
      image:
        'images/bkv.jpeg',
      shortDesc: 'Otomatik gübre dozajlama',
      price: '₺4.000 - ₺18.000',
      features: ['2 yıl garanti'],
      specs: {
        
      },
      usageAreas: [''],
      description:
        'Vana ürünlerinde müşteri memnuniyetini esas alıp, AR-GE çalışmaları ile kendini sürekli geliştirmektedir. Sektöründe teknoloji, bilgi ve tecrübesi ile bir dünya firması olmayı hedeflemektedir.'
    },
    {
      id: 7,
      name: 'Çelik Pvc ve Kauçuk Hortumlar ',
      category: 'all',
      image:
        'images/celik.jpeg',
      shortDesc: 'Güçlü su basınç çözümü',
      price: '₺6.000 - ₺30.000',
      features: ['2 yıl garanti'],
      specs: {
       
      },
      usageAreas: [''],
      description:
        'Tedarikçilerimizin, çalışanlarımızın ve siz değerli müşterilerimizin desteğiyle Çelik Hortum’da yenilikçi ve kaliteden ödün vermeyen iş anlayışını taşımak için soluksuz çalışıyoruz. Kalite politikalarımız ile Türk Gıda Kalitesi Ve Güvenliği mevzuatınca en uygun çözümleri sunuyoruz.'
    },
    {
      id: 8,
      name: 'Sertsan Plastik',
      category: 'all',
      image:
        'images/sertsan.jpeg',
      shortDesc: 'Sertsan özel sulama çözümü',
      price: '₺8.000 - ₺40.000',
      features: ['2 yıl garanti'],
      specs: {
        
      },
      usageAreas: [''],
      description:
        'Sertsan Plastik kısa sürede yakaladığı büyüme, ürün çeşitliliği ve hizmeti ile beraber ülke genelinde ve yurtdışında adından sıkça söz ettirmiş ve  bulunduğu bölge ve çevre ülkelerde aranan bir marka olmuştur. '
    },
    {
      id: 9,
      name: 'Netafim Sulama Sistemi',
      category: 'all',
      image:
        'images/netafim.jpeg',
      shortDesc: 'Dünya lideri damla sulama teknolojisi',
      price: '₺10.000 - ₺50.000',
      features: ['2 yıl garanti'],
      specs: {
       
      },
      usageAreas: [''],
      description:
        'Çiftçi ruhumuz yenilikçi olmayı da beraberinde getirdi. 1965 yılında,  İsrail’in Negev Çölü topraklarındaki yetiştiriciliğimizle bu işe başladık. Bu yüzden zorlu koşullarda çiftçilik yapmanın ne demek olduğunu çok iyi biliriz. Bu mücadele bize, çiftçilerin farklı bitki ve iklim çeşitlerinde daha azla daha fazla yetiştirmesine yardımcı olacak akıllı sulama, agronomik uzmanlık ve sonsuz inovasyonu nasıl birleştireceğimizi öğretti.'
    },
    {
      id: 10,
      name: 'Yusal Vana ',
      category: 'all',
      image:
        'images/yusal.jpeg',
      shortDesc: 'Akıllı sulama programlama',
      price: '₺800 - ₺3.500',
      features: ['2 yıl garanti'],
      specs: {
        
      },
      usageAreas: [''],
      description:
        'Yusal Vananın ürünleri, titiz bir kalite kontrol sürecinden geçer, yerel ve uluslararası standartlara uygunluğu sağlanır. Bu sayede müşterilere yüksek kaliteli ve güvenilir ürünler sunulur. Her bir ürün, sektördeki en güncel standartlara ve taleplere uygun olarak tasarlanır. Sektördeki gelişmeler yakından takip edilerek ürün portföyü sürekli olarak güncellenir ve müşterilere kaliteli ve uygun fiyatlı hizmet sunulur.'
    },
    {
      id: 11,
      name: 'İnfit Bağlantı Parçaları',
      category: 'all',
      image:
        'images/infit.jpeg',
      shortDesc: 'Ayarlanabilir yağmurlama başlıkları',
      price: '₺500 - ₺2.000',
      features: ['2 yıl garanti'],
      specs: {
        
      },
      usageAreas: [''],
      description:
        ''
    }
  ];

  // Filtrelenmiş ürünler
  const filteredProducts = selectedCategory === 'all' 
    ? products 
    : products.filter(product => product.category === selectedCategory);

  // Modal kapatma fonksiyonu
  const closeModal = () => {
    setSelectedProduct(null);
    setShowPdfViewer(false);
    document.body.style.overflow = 'unset';
  };

  // Modal açma fonksiyonu
  const openModal = (product: any) => {
    setSelectedProduct(product);
    document.body.style.overflow = 'hidden';
  };

  // PDF görüntüleyici açma fonksiyonu
  const openPdfViewer = () => {
    setShowPdfViewer(true);
  };

  // PDF görüntüleyici kapatma fonksiyonu
  const closePdfViewer = () => {
    setShowPdfViewer(false);
  };

  // ESC tuşu ile modal kapatma
  useEffect(() => {
    const handleEsc = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        closeModal();
      }
    };
    
    if (selectedProduct) {
      document.addEventListener('keydown', handleEsc);
    }
    
    return () => {
      document.removeEventListener('keydown', handleEsc);
    };
  }, [selectedProduct]);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <header>
        <h1 style={{ position: 'absolute', left: '-9999px' }}>Ürünlerimiz - GüvenTar Sistemleri</h1>
      </header>

      {/* Language Toggle Button - Hidden on Mobile */}
      <div className="fixed top-4 sm:top-6 right-4 sm:right-6 z-50 hidden sm:block">
        <button
          onClick={toggleLanguage}
          className="group relative flex items-center space-x-2 sm:space-x-3 bg-white/90 backdrop-blur-md text-gray-700 px-4 sm:px-6 py-2 sm:py-3 rounded-full border border-gray-200/50 hover:bg-white hover:shadow-lg transition-all duration-300 cursor-pointer whitespace-nowrap"
        >
          <div className="w-6 h-6 sm:w-8 sm:h-8 bg-gradient-to-br from-green-800 to-green-900 rounded-full flex items-center justify-center shadow-sm">
            <i className="ri-global-line text-white text-sm sm:text-lg"></i>
          </div>
          <div className="hidden sm:flex flex-col items-start">
            <span className="text-xs text-gray-500 font-medium">{t('language.label')}</span>
            <span className="text-sm font-semibold text-gray-800">
              {t('language.switch')}
            </span>
          </div>
          <span className="sm:hidden text-sm font-semibold text-gray-800">
            {language === 'tr' ? 'EN' : 'TR'}
          </span>
          <i className="ri-arrow-down-s-line text-gray-400 group-hover:text-gray-600 transition-colors hidden sm:block"></i>
        </button>
      </div>

      {/* Phone Call Button */}
      <a
        href="tel:+905534145263"
        className="fixed right-4 sm:right-6 bottom-20 sm:bottom-24 w-12 h-12 sm:w-14 sm:h-14 bg-blue-600 hover:bg-blue-700 text-white rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 z-40 cursor-pointer"
        title="Hemen Ara"
      >
        <i className="ri-phone-line text-lg sm:text-xl"></i>
      </a>

      {/* WhatsApp Button */}
      <a
        href="https://wa.me/905534145263"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed right-4 sm:right-6 bottom-4 sm:bottom-6 w-12 h-12 sm:w-14 sm:h-14 bg-green-800 hover:bg-green-900 text-white rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 z-40 cursor-pointer"
        title="WhatsApp"
      >
        <i className="ri-whatsapp-line text-lg sm:text-xl"></i>
      </a>

      {/* Main Content with Left Margin for Desktop */}
      <div className="lg:ml-80 min-h-screen flex flex-col">
        {/* Hero Section */}
        <section 
          className="relative py-20 sm:py-24 lg:py-32 bg-cover bg-center"
          style={{
            backgroundImage: `linear-gradient(rgba(27, 94, 32, 0.8), rgba(27, 94, 32, 0.8)), url('https://readdy.ai/api/search-image?query=Modern%20agricultural%20equipment%20showroom%20with%20irrigation%20products%20display%2C%20professional%20farming%20technology%20exhibition%2C%20clean%20organized%20product%20showcase%2C%20green%20and%20white%20color%20scheme&width=1920&height=600&seq=products-hero&orientation=landscape')`
          }}
        >
          <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              {language === 'tr' ? 'Ürünlerimiz' : t('products.hero.title')}
            </h2>
            <p className="text-xl sm:text-2xl text-green-100 leading-relaxed">
              {language === 'tr' ? 'Kaliteli tarımsal sulama çözümleri ve modern teknoloji ürünleri' : t('products.hero.subtitle')}
            </p>
          </div>
        </section>

        {/* Products Content */}
        <div className="flex-1 py-12 sm:py-16 lg:py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            {/* Kategori Filtreleri */}
            <div className="mb-12">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                {language === 'tr' ? 'Ürün Kategorileri' : t('products.categories.title')}
              </h3>
              <div className="flex flex-wrap justify-center gap-3">
                {categories.map((category) => (
                  <button
                    key={category.id}
                    onClick={() => setSelectedCategory(category.id)}
                    className={`flex items-center space-x-2 px-4 py-2 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap ${
                      selectedCategory === category.id
                        ? 'bg-green-800 text-white shadow-lg'
                        : 'bg-white text-gray-700 hover:bg-green-50 border border-gray-200'
                    }`}
                  >
                    <i className={`${category.icon} text-lg`}></i>
                    <span className="font-medium">{category.name}</span>
                  </button>
                ))}
              </div>
            </div>

            {/* Ürün Kartları */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredProducts.map((product) => (
                <div
                  key={product.id}
                  className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group cursor-pointer hover:scale-105"
                  onClick={() => openModal(product)}
                >
                  <div className="relative overflow-hidden">
                    <img
                      src={product.image}
                      alt={product.name}
                      className="w-full h-48 object-cover object-center group-hover:scale-110 transition-transform duration-500"
                    />
                    
                  </div>
                  
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-gray-900 mb-2" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                      {product.name}
                    </h3>
                    <p className="text-gray-600 mb-4">{product.shortDesc}</p>
                    
                  
                    
                 
                    
                    <button className="w-full bg-green-800 text-white py-3 rounded-xl font-semibold hover:bg-green-900 transition-colors cursor-pointer whitespace-nowrap">
                      <i className="ri-eye-line mr-2"></i>
                      Detayları Görüntüle
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <Footer />
      </div>

      {/* Ürün Detay Modalı */}
      {selectedProduct && !showPdfViewer && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
            {/* Modal Header */}
            <div className="sticky top-0 bg-white border-b border-gray-200 p-6 flex items-center justify-between">
              <h2 className="text-2xl font-bold text-gray-900" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                {selectedProduct.name}
              </h2>
              <button
                onClick={closeModal}
                className="w-10 h-10 bg-gray-100 hover:bg-gray-200 rounded-full flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-xl text-gray-600"></i>
              </button>
            </div>

            {/* Modal Content */}
            <div className="p-6">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                {/* Ürün Görseli */}
                <div>
                  <img
                    src={selectedProduct.image}
                    alt={selectedProduct.name}
                    className="w-full h-64 lg:h-80 object-cover object-center rounded-xl"
                  />
                  <div className="mt-4 flex items-center justify-between">
                  
                  </div>
                </div>

                {/* Ürün Bilgileri */}
                <div>
                  <p className="text-gray-600 mb-6 leading-relaxed">
                    {selectedProduct.description}
                  </p>

                  {/* Özellikler */}
                  <div className="mb-6">
                    <h3 className="text-lg font-semibold text-gray-900 mb-3">Özellikler</h3>
                    <div className="space-y-2">
                      {selectedProduct.features.map((feature: string, index: number) => (
                        <div key={index} className="flex items-center">
                          <i className="ri-check-line text-green-800 mr-3"></i>
                          <span className="text-gray-700">{feature}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Teknik Özellikler */}
                  <div className="mb-6">
                    
                    <div className="bg-gray-50 rounded-xl p-4">
                      {Object.entries(selectedProduct.specs).map(([key, value]) => (
                        <div key={key} className="flex justify-between py-2 border-b border-gray-200 last:border-b-0">
                          <span className="font-medium text-gray-700">{key}:</span>
                          <span className="text-gray-600">{value}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Kullanım Alanları */}
                  <div>
                   
                    <div className="flex flex-wrap gap-2">
                      {selectedProduct.usageAreas.map((area: string, index: number) => (
                        <span
                          key={index}
                          className="bg-green-100 text-green-900 px-3 py-1 rounded-full text-sm font-medium"
                        >
                          {area}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Modal Footer */}
            <div className="sticky bottom-0 bg-white border-t border-gray-200 p-6 flex flex-col sm:flex-row gap-4">
              <button
                onClick={openPdfViewer}
                className="flex-1 bg-green-800 text-white py-3 px-6 rounded-xl font-semibold hover:bg-green-900 transition-colors text-center cursor-pointer whitespace-nowrap"
              >
                <i className="ri-file-pdf-line mr-2"></i>
                Ürünleri Gör (PDF Katalog)
              </button>
              <a
                href="https://wa.me/905534145263"
                target="_blank"
                rel="noopener noreferrer"
                className="flex-1 bg-blue-600 text-white py-3 px-6 rounded-xl font-semibold hover:bg-blue-700 transition-colors text-center cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-line mr-2"></i>
                WhatsApp ile İletişim
              </a>
              <a
                href="tel:+905534145263"
                className="flex-1 bg-orange-600 text-white py-3 px-6 rounded-xl font-semibold hover:bg-orange-700 transition-colors text-center cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                Teklif Al
              </a>
            </div>

          </div>
        </div>
      )}

      {/* PDF Görüntüleyici */}
      {showPdfViewer && (
        <div className="fixed inset-0 bg-white z-50 flex flex-col">
          {/* PDF Header */}
          <div className="bg-gray-900 text-white p-4 flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <button
                onClick={closePdfViewer}
                className="w-10 h-10 bg-gray-700 hover:bg-gray-600 rounded-full flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-arrow-left-line text-xl"></i>
              </button>
              <h2 className="text-xl font-semibold" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                GüvenTar Sulama Sistemleri - Ürün Katalogu
              </h2>
            </div>
            <div className="flex items-center space-x-2">
              <span className="text-sm text-gray-300">Sayfa 1 / 8</span>
            </div>
          </div>

          {/* PDF Content */}
          <div className="flex-1 overflow-y-auto bg-gray-100 p-4">
            <div className="max-w-4xl mx-auto space-y-6">
              
              {/* Sayfa 1 - Kapak */}
              <div className="bg-white rounded-lg shadow-lg p-8 min-h-[800px] flex flex-col justify-center items-center">
                <img 
                  src="https://static.readdy.ai/image/6464ee4f71a2ee332e3d69d3173c1c98/7d3cee2b25f83d4d3d1acc2443f38ee1.png" 
                  alt="GüvenTar Logo" 
                  className="w-32 h-32 object-contain mb-8"
                />
                <h1 className="text-4xl font-bold text-green-800 mb-4 text-center" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  ÜRÜN KATALOGU
                </h1>
                <h2 className="text-2xl text-gray-700 mb-8 text-center">
                  Tarımsal Sulama Sistemleri
                </h2>
                <div className="text-center text-gray-600">
                  <p className="mb-2">25 Yılı Aşkın Tecrübe</p>
                  <p className="mb-2">Kaliteli Çözümler</p>
                  <p>Güvenilir Hizmet</p>
                </div>
                <div className="mt-12 text-center text-sm text-gray-500">
                  <p>2024 Katalog</p>
                </div>
              </div>

              {/* Sayfa 2 - Damla Sulama Sistemleri */}
              <div className="bg-white rounded-lg shadow-lg p-8 min-h-[800px]">
                <h2 className="text-3xl font-bold text-green-800 mb-6" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Damla Sulama Sistemleri
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <img 
                      src="https://static.readdy.ai/image/6464ee4f71a2ee332e3d69d3173c1c98/5f22b47c0804b45efd1eb1fd8753f9fb.jpeg" 
                      alt="Damla Sulama Sistemi" 
                      className="w-full h-48 object-cover rounded-lg mb-4"
                    />
                    <h3 className="text-xl font-semibold mb-3">Premium Damla Sulama</h3>
                    <ul className="space-y-2 text-sm text-gray-600">
                      <li>• Su tasarrufu %40-60</li>
                      <li>• Otomatik kontrol sistemi</li>
                      <li>• UV korumalı malzeme</li>
                      <li>• 5 yıl garanti</li>
                    </ul>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold mb-3">Teknik Özellikler</h4>
                    <table className="w-full text-sm">
                      <tr className="border-b">
                        <td className="py-2 font-medium">Debi Aralığı:</td>
                        <td className="py-2">2-8 L/saat</td>
                      </tr>
                      <tr className="border-b">
                        <td className="py-2 font-medium">Çalışma Basıncı:</td>
                        <td className="py-2">1-3 bar</td>
                      </tr>
                      <tr className="border-b">
                        <td className="py-2 font-medium">Malzeme:</td>
                        <td className="py-2">PE + UV koruma</td>
                      </tr>
                      <tr>
                        <td className="py-2 font-medium">Sıcaklık Dayanımı:</td>
                        <td className="py-2">-10°C / +50°C</td>
                      </tr>
                    </table>
                    <div className="mt-6">
                      <h4 className="text-lg font-semibold mb-3">Kullanım Alanları</h4>
                      <div className="flex flex-wrap gap-2">
                        <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-xs">Sera Üretimi</span>
                        <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-xs">Açık Alan Tarımı</span>
                        <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-xs">Meyve Bahçeleri</span>
                        <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-xs">Sebze Üretimi</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Sayfa 3 - Yağmurlama Sistemleri */}
              <div className="bg-white rounded-lg shadow-lg p-8 min-h-[800px]">
                <h2 className="text-3xl font-bold text-green-800 mb-6" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Yağmurlama Sistemleri
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <img 
                      src="https://readdy.ai/api/search-image?query=Professional%20sprinkler%20irrigation%20system%20working%20in%20agricultural%20field%2C%20water%20spray%20pattern%20visible%2C%20green%20crops%20being%20watered%2C%20modern%20farming%20equipment%2C%20professional%20agricultural%20technology&width=400&height=300&seq=pdf-sprinkler-1&orientation=landscape" 
                      alt="Yağmurlama Sistemi" 
                      className="w-full h-48 object-cover rounded-lg mb-4"
                    />
                    <h3 className="text-xl font-semibold mb-3">Profesyonel Yağmurlama</h3>
                    <ul className="space-y-2 text-sm text-gray-600">
                      <li>• 360° sulama kapasitesi</li>
                      <li>• Ayarlanabilir debi kontrolü</li>
                      <li>• Paslanmaz çelik malzeme</li>
                      <li>• 3 yıl garanti</li>
                    </ul>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold mb-3">Teknik Özellikler</h4>
                    <table className="w-full text-sm">
                      <tr className="border-b">
                        <td className="py-2 font-medium">Sulama Çapı:</td>
                        <td className="py-2">10-30 metre</td>
                      </tr>
                      <tr className="border-b">
                        <td className="py-2 font-medium">Debi:</td>
                        <td className="py-2">5-25 L/dakika</td>
                      </tr>
                      <tr className="border-b">
                        <td className="py-2 font-medium">Çalışma Basıncı:</td>
                        <td className="py-2">2-4 bar</td>
                      </tr>
                      <tr>
                        <td className="py-2 font-medium">Malzeme:</td>
                        <td className="py-2">Paslanmaz çelik + Plastik</td>
                      </tr>
                    </table>
                    <div className="mt-6">
                      <h4 className="text-lg font-semibold mb-3">Kullanım Alanları</h4>
                      <div className="flex flex-wrap gap-2">
                        <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-xs">Büyük Tarlalar</span>
                        <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-xs">Çim Alanları</span>
                        <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-xs">Spor Sahaları</span>
                        <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-xs">Park ve Bahçeler</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Sayfa 4 - Otomatik Kontrol Sistemleri */}
              <div className="bg-white rounded-lg shadow-lg p-8 min-h-[800px]">
                <h2 className="text-3xl font-bold text-green-800 mb-6" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Otomatik Kontrol Sistemleri
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <img 
                      src="https://readdy.ai/api/search-image?query=Modern%20irrigation%20control%20panel%20with%20digital%20display%20and%20buttons%2C%20automated%20farming%20technology%2C%20smart%20agriculture%20control%20system%2C%20professional%20equipment%20with%20LED%20indicators&width=400&height=300&seq=pdf-automation-1&orientation=landscape" 
                      alt="Otomatik Kontrol Sistemi" 
                      className="w-full h-48 object-cover rounded-lg mb-4"
                    />
                    <h3 className="text-xl font-semibold mb-3">Akıllı Sulama Kontrolü</h3>
                    <ul className="space-y-2 text-sm text-gray-600">
                      <li>• Zamanlayıcı sistemi</li>
                      <li>• Nem sensörü entegrasyonu</li>
                      <li>• Uzaktan kontrol özelliği</li>
                      <li>• 5 yıl garanti</li>
                    </ul>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold mb-3">Teknik Özellikler</h4>
                    <table className="w-full text-sm">
                      <tr className="border-b">
                        <td className="py-2 font-medium">Kontrol Zonu:</td>
                        <td className="py-2">4-16 vana</td>
                      </tr>
                      <tr className="border-b">
                        <td className="py-2 font-medium">Güç:</td>
                        <td className="py-2">220V AC / 24V DC</td>
                      </tr>
                      <tr className="border-b">
                        <td className="py-2 font-medium">Ekran:</td>
                        <td className="py-2">LCD dokunmatik</td>
                      </tr>
                      <tr>
                        <td className="py-2 font-medium">Bağlantı:</td>
                        <td className="py-2">WiFi + GSM</td>
                      </tr>
                    </table>
                    <div className="mt-6">
                      <h4 className="text-lg font-semibold mb-3">Avantajlar</h4>
                      <div className="space-y-2 text-sm text-gray-600">
                        <div className="flex items-center">
                          <i className="ri-check-line text-green-600 mr-2"></i>
                          <span>%30 su tasarrufu</span>
                        </div>
                        <div className="flex items-center">
                          <i className="ri-check-line text-green-600 mr-2"></i>
                          <span>24/7 otomatik çalışma</span>
                        </div>
                        <div className="flex items-center">
                          <i className="ri-check-line text-green-600 mr-2"></i>
                          <span>Mobil uygulama desteği</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Sayfa 5 - Filtre Sistemleri */}
              <div className="bg-white rounded-lg shadow-lg p-8 min-h-[800px]">
                <h2 className="text-3xl font-bold text-green-800 mb-6" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Filtre Sistemleri
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <img 
                      src="https://readdy.ai/api/search-image?query=Professional%20water%20filtration%20system%20for%20irrigation%2C%20stainless%20steel%20filter%20housing%20with%20pressure%20gauges%2C%20clean%20water%20treatment%20equipment%2C%20agricultural%20water%20purification%20technology&width=400&height=300&seq=pdf-filter-1&orientation=landscape" 
                      alt="Filtre Sistemi" 
                      className="w-full h-48 object-cover rounded-lg mb-4"
                    />
                    <h3 className="text-xl font-semibold mb-3">Gelişmiş Su Arıtma</h3>
                    <ul className="space-y-2 text-sm text-gray-600">
                      <li>• Çoklu filtreleme teknolojisi</li>
                      <li>• Otomatik temizlik sistemi</li>
                      <li>• Basınç göstergesi</li>
                      <li>• 3 yıl garanti</li>
                    </ul>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold mb-3">Filtreleme Kapasitesi</h4>
                    <div className="space-y-4">
                      <div className="bg-gray-50 p-4 rounded-lg">
                        <h5 className="font-medium mb-2">Kum Filtresi</h5>
                        <p className="text-sm text-gray-600">50-200 mikron filtreleme</p>
                      </div>
                      <div className="bg-gray-50 p-4 rounded-lg">
                        <h5 className="font-medium mb-2">Disk Filtresi</h5>
                        <p className="text-sm text-gray-600">20-400 mikron filtreleme</p>
                      </div>
                      <div className="bg-gray-50 p-4 rounded-lg">
                        <h5 className="font-medium mb-2">Ekran Filtresi</h5>
                        <p className="text-sm text-gray-600">80-3000 mikron filtreleme</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Sayfa 6 - Gübre Karıştırma Sistemleri */}
              <div className="bg-white rounded-lg shadow-lg p-8 min-h-[800px]">
                <h2 className="text-3xl font-bold text-green-800 mb-6" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Gübre Karıştırma Sistemleri
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <img 
                      src="https://readdy.ai/api/search-image?query=Professional%20fertilizer%20injection%20system%20for%20irrigation%2C%20chemical%20dosing%20equipment%20with%20tanks%20and%20pumps%2C%20agricultural%20fertigation%20technology%2C%20modern%20farming%20nutrient%20delivery%20system&width=400&height=300&seq=pdf-fertilizer-1&orientation=landscape" 
                      alt="Gübre Karıştırma Sistemi" 
                      className="w-full h-48 object-cover rounded-lg mb-4"
                    />
                    <h3 className="text-xl font-semibold mb-3">Otomatik Gübre Dozajlama</h3>
                    <ul className="space-y-2 text-sm text-gray-600">
                      <li>• Hassas dozajlama ±2%</li>
                      <li>• Çoklu gübre karışımı</li>
                      <li>• pH kontrolü</li>
                      <li>• 4 yıl garanti</li>
                    </ul>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold mb-3">Sistem Bileşenleri</h4>
                    <div className="space-y-3">
                      <div className="flex items-center space-x-3">
                        <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                          <i className="ri-flask-line text-green-600 text-sm"></i>
                        </div>
                        <div>
                          <h5 className="font-medium">Gübre Tankları</h5>
                          <p className="text-sm text-gray-600">50-500 litre kapasiteli</p>
                        </div>
                      </div>
                      <div className="flex items-center space-x-3">
                        <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                          <i className="ri-settings-line text-blue-600 text-sm"></i>
                        </div>
                        <div>
                          <h5 className="font-medium">Dozaj Pompaları</h5>
                          <p className="text-sm text-gray-600">0.5-2 HP güç aralığı</p>
                        </div>
                      </div>
                      <div className="flex items-center space-x-3">
                        <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center">
                          <i className="ri-dashboard-line text-purple-600 text-sm"></i>
                        </div>
                        <div>
                          <h5 className="font-medium">Kontrol Paneli</h5>
                          <p className="text-sm text-gray-600">Dijital pH/EC metre</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Sayfa 7 - Referanslar ve Projeler */}
              <div className="bg-white rounded-lg shadow-lg p-8 min-h-[800px]">
                <h2 className="text-3xl font-bold text-green-800 mb-6" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Referanslar ve Projeler
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <h3 className="text-xl font-semibold mb-4">Başarılı Projelerimiz</h3>
                    <div className="space-y-4">
                      <div className="border-l-4 border-green-500 pl-4">
                        <h4 className="font-semibold">Antalya Sera Kompleksi</h4>
                        <p className="text-sm text-gray-600">50.000 m² sera alanı - Damla sulama sistemi</p>
                        <p className="text-xs text-gray-500">2023</p>
                      </div>
                      <div className="border-l-4 border-blue-500 pl-4">
                        <h4 className="font-semibold">Mersin Narenciye Bahçesi</h4>
                        <p className="text-sm text-gray-600">200 dekar alan - Mikro yağmurlama sistemi</p>
                        <p className="text-xs text-gray-500">2023</p>
                      </div>
                      <div className="border-l-4 border-purple-500 pl-4">
                        <h4 className="font-semibold">Konya Tarım İşletmesi</h4>
                        <p className="text-sm text-gray-600">500 dekar alan - Otomatik kontrol sistemi</p>
                        <p className="text-xs text-gray-500">2022</p>
                      </div>
                    </div>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold mb-4">Müşteri Memnuniyeti</h3>
                    <div className="text-center mb-6">
                      <div className="text-4xl font-bold text-green-600 mb-2">98%</div>
                      <p className="text-gray-600">Müşteri Memnuniyet Oranı</p>
                    </div>
                    <div className="space-y-4">
                      <div className="bg-gray-50 p-4 rounded-lg">
                        <div className="flex items-center mb-2">
                          <div className="flex text-yellow-400">
                            <i className="ri-star-fill"></i>
                            <i className="ri-star-fill"></i>
                            <i className="ri-star-fill"></i>
                            <i className="ri-star-fill"></i>
                            <i className="ri-star-fill"></i>
                          </div>
                          <span className="ml-2 text-sm font-medium">5.0/5</span>
                        </div>
                        <p className="text-sm text-gray-600 italic">
                          "Kaliteli ürünler ve mükemmel hizmet. Su tasarrufu gerçekten etkileyici."
                        </p>
                        <p className="text-xs text-gray-500 mt-2">- Ahmet Bey, Antalya</p>
                      </div>
                      <div className="bg-gray-50 p-4 rounded-lg">
                        <div className="flex items-center mb-2">
                          <div className="flex text-yellow-400">
                            <i className="ri-star-fill"></i>
                            <i className="ri-star-fill"></i>
                            <i className="ri-star-fill"></i>
                            <i className="ri-star-fill"></i>
                            <i className="ri-star-fill"></i>
                          </div>
                          <span className="ml-2 text-sm font-medium">5.0/5</span>
                        </div>
                        <p className="text-sm text-gray-600 italic">
                          "Profesyonel ekip, zamanında teslimat. Çok memnunuz."
                        </p>
                        <p className="text-xs text-gray-500 mt-2">- Fatma Hanım, Mersin</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Sayfa 8 - İletişim */}
              <div className="bg-white rounded-lg shadow-lg p-8 min-h-[800px] flex flex-col justify-center">
                <div className="text-center mb-8">
                  <img 
                    src="https://static.readdy.ai/image/6464ee4f71a2ee332e3d69d3173c1c98/7d3cee2b25f83d4d3d1acc2443f38ee1.png" 
                    alt="GüvenTar Logo" 
                    className="w-24 h-24 object-contain mx-auto mb-6"
                  />
                  <h2 className="text-3xl font-bold text-green-800 mb-4" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    İletişim Bilgileri
                  </h2>
                  <p className="text-gray-600 mb-8">
                    Projeleriniz için ücretsiz keşif ve danışmanlık hizmeti
                  </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  <div className="space-y-6">
                    <div className="flex items-center space-x-4">
                      <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                        <i className="ri-map-pin-line text-green-600 text-xl"></i>
                      </div>
                      <div>
                        <h4 className="font-semibold">Adres</h4>
                        <p className="text-sm text-gray-600">Cumalı, Antalya Cd. No:9, 07500 Serik/Antalya</p>
                      </div>
                    </div>
                    <div className="flex items-center space-x-4">
                      <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                        <i className="ri-phone-line text-blue-600 text-xl"></i>
                      </div>
                      <div>
                        <h4 className="font-semibold">Telefon</h4>
                        <p className="text-sm text-gray-600">+90 553 414 52 63</p>
                      </div>
                    </div>
                    <div className="flex items-center space-x-4">
                      <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center">
                        <i className="ri-mail-line text-purple-600 text-xl"></i>
                      </div>
                      <div>
                        <h4 className="font-semibold">E-posta</h4>
                        <p className="text-sm text-gray-600">info@guventarsulama.com</p>
                      </div>
                    </div>
                  </div>
                  <div className="space-y-6">
                    <div className="bg-green-50 p-6 rounded-lg">
                      <h4 className="font-semibold text-green-800 mb-3">Çalışma Saatleri</h4>
                      <div className="space-y-2 text-sm text-gray-600">
                        <p>Pazartesi - Cumartesi: 08:00 - 18:00</p>
                        <p>Pazar: Kapalı</p>
                      </div>
                    </div>
                    <div className="bg-blue-50 p-6 rounded-lg">
                      <h4 className="font-semibold text-blue-800 mb-3">Hizmet Alanları</h4>
                      <div className="space-y-1 text-sm text-gray-600">
                        <p>• Antalya ve çevre iller</p>
                        <p>• Türkiye geneli proje desteği</p>
                        <p>• 7/24 teknik destek</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="text-center mt-8 pt-8 border-t border-gray-200">
                  <p className="text-gray-500 text-sm">
                    © 2024 GüvenTar Sulama Sistemleri. Tüm hakları saklıdır.
                  </p>
                </div>
              </div>

            </div>
          </div>
        </div>
      )}

    </div>
  );
}
